import { Button, buttonClasses, ButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { config } from '../../../styles/config';

export const PublicButton = styled(Button)<ButtonProps>(({ theme }) => ({
  [`&.${buttonClasses.root}`]: {
    width: 'fit-content',
    backgroundColor: theme.palette.lwWhite[100],
    borderRadius: theme.spacing(7),
    border: `1px solid ${theme.palette.lwBlack[100]}`,
    color: theme.palette.lwBlack[100],
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 700,
    textTransform: 'none',
    padding: theme.spacing(3, 6),
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    [`&.${buttonClasses.disabled}`]: {
      cursor: 'not-allowed',
      pointerEvents: 'none',
      borderColor: theme.palette.lwBlack[40],
      color: theme.palette.lwBlack[40],
      [`& .${buttonClasses.startIcon} svg path`]: {
        fill: theme.palette.lwBlack[40],
      },
    },

    [`&.${buttonClasses.contained}`]: {
      backgroundColor: config.colors.primary,
      boxShadow: 'none',
      border: 'none',
      fontVariationSettings: '"wght" 600',
    },
  },
}));
